export type MediaWatch = {
  iceConnected: boolean;
  frame: boolean;
};

export function missLabel(watch: MediaWatch, trigger: "ice-failed" | "budget"): string {
  if (watch.iceConnected && !watch.frame) return "no-first-frame";
  if (trigger === "ice-failed") return "ice-fail";
  return "Media did not connect";
}
